import { createAction } from '@reduxjs/toolkit'

export const addAprForLiquidityMiningPool = createAction<{ address: string; apr: number }>(
  'aprs/addAprForLiquidityMiningPool',
)
export const addAprForRewardPool = createAction<{ address: string; apr: number }>('aprs/addAprForRewardPool')
export const reset = createAction('aprs/reset')
export const clear = createAction('aprs/clear')
